import dayjs from 'dayjs'
import React, { useEffect, useMemo, useRef } from 'react'
import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'
import { useRequestHandler } from '@/hooks/useRequestHandler'

import { Slot } from '@/core/models/schedule.model'

import { useAppDispatch, useAppSelector } from '@/redux/rootReducer'
import { getMyAvailability, selectAuthUserUpdateRequestState, updateMyAvailability } from '@/redux/reducers/auth.reducer'

import { SelectTimeSlot as SelectTimeSlotComponent, SelectTimeSlotHandle, SelectTimeSlotValues } from '../components/SelectTimeSlot'

export function SelectTimeSlot() {
  const dispatch = useAppDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const selectTimeSlotRef = useRef<SelectTimeSlotHandle>(null)

  const updateAvailabilityRequestHandler = useRequestHandler<Slot[]>({
    onSuccess: (dispatchedPayload) => {
      const slots = dispatchedPayload
      enqueueSnackbar(t('notification.availability.update.success'), { variant: 'success' })
      if (slots && !!slots.length) selectTimeSlotRef.current?.toggleEditable()
    },
    onError: () => {
      enqueueSnackbar(t('notification.availability.update.error'), { variant: 'error' })
    },
    requestTrackerSelector: selectAuthUserUpdateRequestState,
  })

  useEffect(() => {
    dispatch(getMyAvailability())
  }, [dispatch])

  const myAvailibility = useAppSelector((state) => state.auth.availability)

  const initialValues = useMemo(() => {
    return {
      slots: myAvailibility.map((value) => {
        return {
          start: dayjs(value.start).toDate(),
          end: dayjs(value.end).toDate(),
        }
      }),
    }
  }, [myAvailibility])

  const submitAvailibility = (values: SelectTimeSlotValues) => {
    updateAvailabilityRequestHandler.dispatch(
      updateMyAvailability(
        values.slots.map((slot) => {
          return {
            start: dayjs(slot.start).toISOString(),
            end: dayjs(slot.end).toISOString(),
          }
        })
      )
    )
  }

  return (
    <SelectTimeSlotComponent
      ref={selectTimeSlotRef}
      initialValues={initialValues}
      isSubmitting={updateAvailabilityRequestHandler.requestTracker.loading}
      onSelectTimeSlot={submitAvailibility}
    />
  )
}

export default SelectTimeSlot
